<script lang="ts" setup>
defineProps({
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  size: {
    default: 'sm',
    type: String as PropType<UAvatarSize>,
  },
  technologies: {
    default: () => [],
    type: Array as PropType<CompanyTechnologiesTechnologies>,
  },
  technologiesDetails: {
    default: () => [],
    type: Array as PropType<CompanyTechnologiesDetails[]>,
  },
})

const { getCompaniesSearchUrl } = useSegmentation()
const localePath = useLocalePath()
</script>

<template>
  <div
    class="flex select-none flex-wrap items-center"
    :class="{
      'gap-1.5': ['xs', 'sm'].includes(size),
      'gap-2.5': ['md', 'lg', 'xl', '2xl'].includes(size),
    }"
  >
    <template
      v-for="(technology, technologyIndex) in technologies"
      :key="technology"
    >
      <template v-if="technologyIndex < max">
        <UTooltip :text="`${changeCase.noCase(technology)} ${technologiesDetails.find(detail => detail.slug === technology)?.version ? `(${technologiesDetails.find(detail => detail.slug === technology)?.version})` : ''}`">
          <ULink
            class="relative"
            :class="{
              'size-6': size === 'xs',
              'size-8': size === 'sm',
              'size-10': size === 'md',
              'size-12': size === 'lg',
              'size-14': size === 'xl',
              'size-16': size === '2xl',
            }"
            :to="localePath(getCompaniesSearchUrl({
              attribute: 'technologies.active',
              value: technology,
            }))"
          >
            <UAvatar
              :alt="technology"
              :shadow="false"
              :size="size"
              :src="getLogo(technology, 'technologies')"
            />

            <div class="absolute -bottom-1.5 -right-1 max-w-12">
              <UBadge
                v-if="size !== 'xs' && technologiesDetails.find(detail => detail.slug === technology)?.version"
                class="text-2xs w-full overflow-hidden border-indigo-400 !px-1 !py-0.5 dark:border-indigo-600"
                color="gray"
                size="xs"
                variant="solid"
              >
                <span class="truncate">
                  {{ technologiesDetails.find(detail => detail.slug === technology)?.version }}
                </span>
              </UBadge>
            </div>
          </ULink>
        </UTooltip>
      </template>
    </template>

    <div
      v-if="technologies.length > max"
      key="max"
      class="flex items-center justify-center rounded-md bg-gray-100 px-1 text-xs text-gray-500 dark:bg-gray-800 dark:text-gray-400"
      :class="{
        'h-6 min-w-6': size === 'xs',
        'h-8 min-w-8': size === 'sm',
        'h-10 min-w-10': size === 'md',
        'h-12 min-w-12': size === 'lg',
        'h-14 min-w-14': size === 'xl',
      }"
    >
      +{{ technologies.length - max }}
    </div>
  </div>
</template>
